export enum HTTP_STATUS_CODE {
  ok = 200,
  unauthorized = 401,
  noContent = 204,
  unexpected = 400,
  notFound = 404,
  severError = 500,
}

export interface IHttpResponse<Body> {
  statusCode: HTTP_STATUS_CODE;
  body?: Body;
}
